import githubLogo from "../icons/github.svg";
import instagramLogo from "../icons/instagram.svg";
import kitLogo from "../icons/kit.svg";
import tiktokLogo from "../icons/tiktok.svg";
import twitchLogo from "../icons/twitch.svg";
import twitterLogo from "../icons/twitter.svg";
import discordLogo from "../icons/discord.svg";
import youtubeLogo from "../icons/youtube.svg";
import facebookLogo from "../icons/facebook.svg";
import messengerLogo from "../icons/messenger.svg";
import linkedinLogo from "../icons/linkedin.svg";
import producthuntLogo from "../icons/producthunt.svg";
import snapchatLogo from "../icons/snapchat.svg";
import spotifyLogo from "../icons/spotify.svg";
import redditLogo from "../icons/reddit.svg";
import mediumLogo from "../icons/medium.svg";
import pinterestLogo from "../icons/pinterest.svg";
import soundcloudLogo from "../icons/soundcloud.svg";
import figmaLogo from "../icons/figma.svg";
import telegramLogo from "../icons/telegram.svg";
import tumblrLogo from "../icons/tumblr.svg";
import steamLogo from "../icons/steam.svg";
import vimeoLogo from "../icons/vimeo.svg";
import wordpressLogo from "../icons/wordpress.svg";
import goodreadsLogo from "../icons/goodreads.svg";
import skoobLogo from "../icons/skoob.svg";
import letterboxdLogo from "../icons/letterboxd.svg";
import mastodonLogo from "../icons/mastodon.svg";
import microblogLogo from "../icons/microblog.svg";
import emailLogo from "../icons/email.svg";
import emailAltLogo from "../icons/email_alt.svg";
import whatsappLogo from "../icons/whatsapp.svg";
import stravaLogo from "../icons/strava.svg";
import blueSkyLogo from "../icons/bluesky.svg";
import buyMeACoffeeLogo from "../icons/buymeacoffee.svg";
import gitlabLogo from "../icons/gitlab.svg";
import patreonLogo from "../icons/patreon.svg";
import devtoLogo from "../icons/devto.svg";
import paypalLogo from "../icons/paypal.svg";
import slackLogo from "../icons/slack.svg";
import stackoverflowLogo from "../icons/stackoverflow.svg";
import lastfmLogo from "../icons/lastfm.svg";
import giteaLogo from "../icons/gitea.svg";
import polyworkLogo from "../icons/polywork.svg";
import signalLogo from "../icons/signal.svg";
import untappdLogo from "../icons/untappd.svg";
import instantGamingLogo from "../icons/instantgaming.svg";
import ghostLogo from "../icons/ghost.svg";
import traktLogo from "../icons/trakt.svg";
import cashappLogo from "../icons/cashapp.svg";
import teespringLogo from "../icons/teespring.svg";
import xingLogo from "../icons/xing.svg";
import keybaseLogo from "../icons/keybase.svg";
import onlyfansLogo from "../icons/onlyfans.svg";
import sessionLogo from "../icons/session.svg";
import threemaLogo from "../icons/threema.svg";
import streamlabsLogo from "../icons/streamlabs.svg";
import privatebinLogo from "../icons/privatebin.svg";
import amazonLogo from "../icons/amazon.svg";
import applemusicLogo from "../icons/applemusic.svg";
import youtubemusicLogo from "../icons/youtubemusic.svg";
import venmoLogo from "../icons/venmo.svg";
import statusLogo from "../icons/status.svg";
import matrixLogo from "../icons/matrix.svg";
import anilistLogo from "../icons/anilist.svg";
import gitbucketLogo from "../icons/gitbucket.svg";
import shazamLogo from "../icons/shazam.svg";
import flickrLogo from "../icons/flickr.svg";
import tpdbLogo from "../icons/tpdb.svg";
import osuLogo from "../icons/osu.svg";
import lineLogo from "../icons/linemessenger.svg";
import kakaoLogo from "../icons/kaokotalk.svg";
import designByHumansLogo from "../icons/designbyhumans.svg";
import dockerhubLogo from "../icons/docker.svg";
import veroLogo from "../icons/vero.svg";
import myAnimeListLogo from "../icons/myanimelist.svg";
import fiveHundredPXLogo from "../icons/500px.svg";
import jetphotosLogo from "../icons/jetphotos.svg";
import substackLogo from "../icons/substack.svg";
import printablesLogo from "../icons/printables.svg";
import serializdLogo from "../icons/serializd.svg";
import threadsLogo from "../icons/threads.svg";
import lemmyLogo from "../icons/lemmy.svg";
import pixelfedLogo from "../icons/pixelfed.svg";
import vrchatLogo from "../icons/vrchat.svg";
import xLogo from "../icons/x.svg";
import codewarsLogo from "../icons/codewars.svg";
import applePodcastsLogo from "../icons/apple-podcasts.svg";
import googlePodcastsLogo from "../icons/google-podcasts.svg";
import pocketCastsLogo from "../icons/pocketcasts.svg";
import overcastLogo from "../icons/overcast.svg";
import rssLogo from "../icons/generic-rss.svg";
import audiusLogo from "../icons/audius.svg";
import bandcampLogo from "../icons/bandcamp.svg";
import forgejoLogo from "../icons/forgejo.svg";
import orcidLogo from "../icons/orcid.svg";
import credlyLogo from "../icons/credly.svg";
import semanticscholarLogo from "../icons/semanticscholar.svg";
import googlescholarLogo from "../icons/googlescholar.svg";
import simplexLogo from "../icons/simplex.svg";
import mixcloudLogo from "../icons/mixcloud.svg";
import internetarchiveLogo from "../icons/internetarchive.svg";
import googlemapsLogo from "../icons/googlemaps.svg";
import tidalLogo from "../icons/tidal.svg";
import thestorygraphLogo from "../icons/storygraph.svg";
import geocachingLogo from "../icons/geocaching.svg";
import neocitiesLogo from "../icons/neocities.svg";
import dreamwidthLogo from "../icons/dreamwidth.svg";
import spaceheyLogo from "../icons/spacehey.svg";
import viberLogo from "../icons/viber.svg";
import pillowfortLogo from "../icons/pillowfort.svg";
import makerworldLogo from "../icons/makerworld.svg";
import shopeeLogo from "../icons/shopee.svg";
import tokopediaLogo from "../icons/tokopedia.svg";
import tokocat1Logo from "../icons/tokocat1.png";
import paintproLogo from "../icons/paintpro.png";

const BUTTON_TYPES = {
  GITHUB: {
    text: "Github",
    logo: githubLogo,
  },

  INSTAGRAM: {
    text: "Instagram",
    logo: instagramLogo,
  },

  KIT: {
    text: "Kit",
    logo: kitLogo,
  },

  TIKTOK: {
    text: "TikTok",
    logo: tiktokLogo,
  },

  TWITCH: {
    text: "Twitch",
    logo: twitchLogo,
  },

  TWITTER: {
    text: "Twitter",
    logo: twitterLogo,
  },

  DISCORD: {
    text: "Discord",
    logo: discordLogo,
  },

  YOUTUBE: {
    text: "YouTube",
    logo: youtubeLogo,
  },

  FACEBOOK: {
    text: "Facebook",
    logo: facebookLogo,
  },

  MESSENGER: {
    text: "Messenger",
    logo: messengerLogo,
  },

  LINKEDIN: {
    text: "LinkedIn",
    logo: linkedinLogo,
  },

  PRODUCTHUNT: {
    text: "Product Hunt",
    logo: producthuntLogo,
  },

  SNAPCHAT: {
    text: "Snapchat",
    logo: snapchatLogo,
  },

  SPOTIFY: {
    text: "Spotify",
    logo: spotifyLogo,
  },

  REDDIT: {
    text: "Reddit",
    logo: redditLogo,
  },

  MEDIUM: {
    text: "Medium",
    logo: mediumLogo,
  },

  PINTEREST: {
    text: "Pinterest",
    logo: pinterestLogo,
  },

  SOUNDCLOUD: {
    text: "SoundCloud",
    logo: soundcloudLogo,
  },

  FIGMA: {
    text: "Figma",
    logo: figmaLogo,
  },

  TELEGRAM: {
    text: "Telegram",
    logo: telegramLogo,
  },

  TUMBLR: {
    text: "Tumblr",
    logo: tumblrLogo,
  },

  STEAM: {
    text: "Steam",
    logo: steamLogo,
  },

  VIMEO: {
    text: "Vimeo",
    logo: vimeoLogo,
  },

  WORDPRESS: {
    text: "WordPress",
    logo: wordpressLogo,
  },

  GOODREADS: {
    text: "Goodreads",
    logo: goodreadsLogo,
  },

  SKOOB: {
    text: "Skoob",
    logo: skoobLogo,
  },

  LETTERBOXD: {
    text: "Letterboxd",
    logo: letterboxdLogo,
  },

  MASTODON: {
    text: "Mastodon",
    logo: mastodonLogo,
  },

  MICROBLOG: {
    text: "Micro.blog",
    logo: microblogLogo,
  },

  EMAIL: {
    text: "Email",
    logo: emailLogo,
  },

  EMAIL_ALT: {
    text: "Email",
    logo: emailAltLogo,
  },

  WHATSAPP: {
    text: "Whatsapp",
    logo: whatsappLogo,
  },

  STRAVA: {
    text: "Strava",
    logo: stravaLogo,
  },

  BLUESKY: {
    text: "Bluesky",
    logo: blueSkyLogo,
  },

  BUYMEACOFFEE: {
    text: "Buy Me a Coffee",
    logo: buyMeACoffeeLogo,
  },

  GITLAB: {
    text: "GitLab",
    logo: gitlabLogo,
  },

  PATREON: {
    text: "Patreon",
    logo: patreonLogo,
  },

  DEVTO: {
    text: "Dev.to",
    logo: devtoLogo,
  },

  PAYPAL: {
    text: "PayPal",
    logo: paypalLogo,
  },

  SLACK: {
    text: "Slack",
    logo: slackLogo,
  },

  STACKOVERFLOW: {
    text: "StackOverflow",
    logo: stackoverflowLogo,
  },

  LASTFM: {
    text: "Last.fm",
    logo: lastfmLogo,
  },

  GITEA: {
    text: "Gitea",
    logo: giteaLogo,
  },

  POLYWORK: {
    text: "Polywork",
    logo: polyworkLogo,
  },

  SIGNAL: {
    text: "Signal",
    logo: signalLogo,
  },

  UNTAPPD: {
    text: "Untappd",
    logo: untappdLogo,
  },

  INSTANTGAMING: {
    text: "Instant Gaming",
    logo: instantGamingLogo,
  },

  GHOST: {
    text: "Ghost",
    logo: ghostLogo,
  },

  TRAKT: {
    text: "Trakt",
    logo: traktLogo,
  },

  CASHAPP: {
    text: "Cash App",
    logo: cashappLogo,
  },

  TEESPRING: {
    text: "Teespring",
    logo: teespringLogo,
  },

  XING: {
    text: "Xing",
    logo: xingLogo,
  },

  KEYBASE: {
    text: "Keybase",
    logo: keybaseLogo,
  },

  ONLYFANS: {
    text: "OnlyFans",
    logo: onlyfansLogo,
  },

  SESSION: {
    text: "Session",
    logo: sessionLogo,
  },

  THREEMA: {
    text: "Threema",
    logo: threemaLogo,
  },

  STREAMLABS: {
    text: "Streamlabs",
    logo: streamlabsLogo,
  },

  PRIVATEBIN: {
    text: "PrivateBin",
    logo: privatebinLogo,
  },

  AMAZON: {
    text: "Amazon",
    logo: amazonLogo,
  },

  APPLEMUSIC: {
    text: "Apple Music",
    logo: applemusicLogo,
  },

  YOUTUBEMUSIC: {
    text: "YouTube Music",
    logo: youtubemusicLogo,
  },

  VENMO: {
    text: "Venmo",
    logo: venmoLogo,
  },

  STATUS: {
    text: "Status",
    logo: statusLogo,
  },

  MATRIX: {
    text: "Matrix",
    logo: matrixLogo,
  },

  ANILIST: {
    text: "AniList",
    logo: anilistLogo,
  },

  GITBUCKET: {
    text: "GitBucket",
    logo: gitbucketLogo,
  },

  SHAZAM: {
    text: "Shazam",
    logo: shazamLogo,
  },

  FLICKR: {
    text: "Flickr",
    logo: flickrLogo,
  },

  TPDB: {
    text: "ThePornDB",
    logo: tpdbLogo,
  },

  OSU: {
    text: "osu!",
    logo: osuLogo,
  },

  LINE: {
    text: "Line",
    logo: lineLogo,
  },

  KAKAO: {
    text: "KakaoTalk",
    logo: kakaoLogo,
  },

  DESIGNBYHUMANS: {
    text: "DesignByHumans",
    logo: designByHumansLogo,
  },

  DOCKERHUB: {
    text: "Docker Hub",
    logo: dockerhubLogo,
  },

  VERO: {
    text: "Vero",
    logo: veroLogo,
  },

  MYANIMELIST: {
    text: "MyAnimeList",
    logo: myAnimeListLogo,
  },

  FIVEHUNDREDPX: {
    text: "500px",
    logo: fiveHundredPXLogo,
  },

  JETPHOTOS: {
    text: "JetPhotos",
    logo: jetphotosLogo,
  },

  SUBSTACK: {
    text: "Substack",
    logo: substackLogo,
  },

  PRINTABLES: {
    text: "Printables",
    logo: printablesLogo,
  },

  SERIALIZD: {
    text: "Serializd",
    logo: serializdLogo,
  },

  THREADS: {
    text: "Threads",
    logo: threadsLogo,
  },

  LEMMY: {
    text: "Lemmy",
    logo: lemmyLogo,
  },

  PIXELFED: {
    text: "Pixelfed",
    logo: pixelfedLogo,
  },

  VRCHAT: {
    text: "VRChat",
    logo: vrchatLogo,
  },

  X: {
    text: "X",
    logo: xLogo,
  },

  CODEWARS: {
    text: "Codewars",
    logo: codewarsLogo,
  },

  APPLEPODCASTS: {
    text: "Apple Podcasts",
    logo: applePodcastsLogo,
  },

  GOOGLEPODCASTS: {
    text: "Google Podcasts",
    logo: googlePodcastsLogo,
  },

  POCKETCASTS: {
    text: "Pocket Casts",
    logo: pocketCastsLogo,
  },

  OVERCAST: {
    text: "Overcast",
    logo: overcastLogo,
  },

  RSS: {
    text: "RSS",
    logo: rssLogo,
  },

  AUDIUS: {
    text: "Audius",
    logo: audiusLogo,
  },

  BANDCAMP: {
    text: "Bandcamp",
    logo: bandcampLogo,
  },

  FORGEJO: {
    text: "Forgejo",
    logo: forgejoLogo,
  },

  ORCID: {
    text: "ORCID",
    logo: orcidLogo,
  },

  CREDLY: {
    text: "Credly",
    logo: credlyLogo,
  },

  SEMANTICSCHOLAR: {
    text: "Semantic Scholar",
    logo: semanticscholarLogo,
  },

  GOOGLESCHOLAR: {
    text: "Google Scholar",
    logo: googlescholarLogo,
  },

  SIMPLEX: {
    text: "SimpleX",
    logo: simplexLogo,
  },

  MIXCLOUD: {
    text: "Mixcloud",
    logo: mixcloudLogo,
  },

  INTERNETARCHIVE: {
    text: "Internet Archive",
    logo: internetarchiveLogo,
  },

  GOOGLEMAPS: {
    text: "Google Maps",
    logo: googlemapsLogo,
  },

  TIDAL: {
    text: "Tidal",
    logo: tidalLogo,
  },

  STORYGRAPH: {
    text: "The StoryGraph",
    logo: thestorygraphLogo,
  },

  GEOCACHING: {
    text: "Geocaching",
    logo: geocachingLogo,
  },

  NEOCITIES: {
    text: "Neocities",
    logo: neocitiesLogo,
  },

  DREAMWIDTH: {
    text: "Dreamwidth",
    logo: dreamwidthLogo,
  },

  SPACEHEY: {
    text: "SpaceHey",
    logo: spaceheyLogo,
  },

  VIBER: {
    text: "Viber",
    logo: viberLogo,
  },

  PILLOWFORT: {
    text: "Pillowfort",
    logo: pillowfortLogo,
  },

  MAKERWORLD: {
    text: "MakerWorld",
    logo: makerworldLogo,
  },

  TOKOPEDIA: {
    text: "Tokopedia",
    logo: tokopediaLogo,
  },

  SHOPEE: {
    text: "Shopee",
    logo: shopeeLogo,
  },

  TOKOCAT1: {
    text: "Toko CAT 1",
    logo: tokocat1Logo,
  },

  PAINTPRO: {
    text: "PaintPro",
    logo: paintproLogo,
  },
};

/** 🔥 Your original function but DRAMATICALLY cleaner */
const getButtonTypes = (type) => {
  const entry = BUTTON_TYPES[type];
  if (!entry) return null;

  return {
    name: type.toLowerCase(),
    text: entry.text,
    logo: entry.logo,
    ordering: type,
  };
};

export default getButtonTypes;
